<template>
  <div class="product-page">
    <banner title="产品中心" />
    <section class="product-panel" v-loading="loading">
      <aside class="product-sidebar">
        <el-menu
          ref="menu"
          unique-opened
          :default-openeds="openIds"
          @open="loadProducts"
          @select="showProductDetail"
        >
          <el-submenu
            v-for="category in productCategories"
            :key="category.id"
            :index="category.id.toString()"
          >
            <template slot="title">
              <i class="el-icon-folder"></i>
              <span>{{ category.name }}</span>
            </template>
            <el-submenu
              v-for="child in category.children"
              :key="child.id"
              :index="child.id.toString()"
            >
              <template slot="title">
                <i class="el-icon-folder"></i>
                <span>{{ child.name }}</span>
              </template>
              <el-menu-item
                v-for="product in child.products"
                :key="product.id"
                class="menu-name"
                :title="product.name"
                :index="product.id.toString()"
              >
                {{ product.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-for="product in category.products"
              :key="product.id"
              class="menu-name"
              :title="product.name"
              :index="product.id.toString()"
            >
              {{ product.name }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </aside>

      <main class="product-main">
        <div class="product-toolbar" v-show="!productId">
          <div>
            <span class="toolbar-kicker">Product Center</span>
            <h2>{{ selectedCategoryName }}</h2>
          </div>
          <span class="product-count">{{ products.length }} 个产品</span>
        </div>

        <div class="product-grid" v-show="!productId && products.length">
          <article class="product-card" v-for="product in products" :key="product.id">
            <div class="product-img">
              <img v-lazy="imgserver + product.image" :alt="product.name" />
            </div>
            <div class="product-info">
              <h3 :title="product.name">{{ product.name }}</h3>
              <p v-if="formatDescription(product.description)">
                {{ formatDescription(product.description) }}
              </p>
              <button type="button" @click="showProductDetail(product.id)">
                <span>查看详情</span>
                <i class="el-icon-right"></i>
              </button>
            </div>
          </article>
        </div>
        <div class="empty-state" v-show="!productId && !products.length && !loading">
          <i class="el-icon-box"></i>
          <p>暂无产品数据</p>
        </div>
        <product-detail @backToList="backToList" v-if="productId" :id="productId" />
      </main>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import ProductDetail from "./ProductDetail.vue";

export default {
  components: {
    Banner,
    ProductDetail
  },
  data() {
    return {
      loading: false,
      productCategories: [],
      products: [],
      productId: null,
      selectedProductCategory: null,
      openIds: []
    };
  },
  computed: {
    selectedCategoryName() {
      const category = this.selectedProductCategory
        ? this.findCategory(this.productCategories, this.selectedProductCategory)
        : null;
      return category ? category.name : "全部产品";
    }
  },
  methods: {
    loadProductCategories() {
      this.loading = true;
      this.$http
        .get("/Product/ProductCategoriesAndProducts")
        .then(response => {
          this.productCategories = response.result || [];
          if (this.productCategories.length > 0) {
            const firstCategory = this.productCategories[0];
            this.selectedProductCategory = firstCategory.id.toString();
            this.openIds = [this.selectedProductCategory];
            this.loadProducts(this.selectedProductCategory);
          }
        })
        .catch(() => {
          this.productCategories = [];
          this.products = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    findCategory(categories, categoryId) {
      for (let i = 0; i < categories.length; i++) {
        const item = categories[i];
        if (item.id.toString() === categoryId.toString()) return item;
        if (item.children && item.children.length) {
          const found = this.findCategory(item.children, categoryId);
          if (found) return found;
        }
      }
      return null;
    },
    loadProducts(categoryId) {
      const category = this.findCategory(this.productCategories, categoryId);
      this.selectedProductCategory = categoryId ? categoryId.toString() : null;
      this.products = category && category.products ? category.products : [];
      this.productId = null;
    },
    showProductDetail(productId) {
      this.productId = Number(productId);
    },
    backToList() {
      this.productId = null;
    },
    formatDescription(content) {
      if (!content) return "";
      return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
    }
  },
  created() {
    this.loadProductCategories();
  }
};
</script>

<style lang="scss" scoped>
.product-page {
  min-height: 100%;
  background: #eef4f8;
}

.product-panel {
  width: min(1240px, 92%);
  margin: -34px auto 56px;
  padding: 22px;
  box-sizing: border-box;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  gap: 22px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 5;
}

.product-sidebar {
  border: 1px solid #e3edf5;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(180deg, #f8fcff, #f1f7fb);
  align-self: start;
  position: sticky;
  top: 90px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
}

.product-sidebar :deep(.el-menu) {
  border-right: 0;
  background: transparent;
}

.product-sidebar :deep(.el-submenu__title),
.product-sidebar :deep(.el-menu-item) {
  height: 44px;
  line-height: 44px;
  color: #24364d;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  margin: 4px 8px;
  padding-right: 12px;
}

.product-sidebar :deep(.el-submenu__title:hover),
.product-sidebar :deep(.el-menu-item:hover) {
  color: #075b94;
  background: #e9f8ff;
}

.product-sidebar :deep(.el-submenu__title i) {
  color: #6f8195;
}

.product-sidebar :deep(.el-menu-item.is-active) {
  color: #075b94;
  background: linear-gradient(180deg, #e9f8ff, #d8f1ff);
  box-shadow: inset 3px 0 0 #2cace2;
}

.product-sidebar :deep(.el-submenu .el-menu-item) {
  min-width: 0;
  padding-left: 38px !important;
  font-size: 13px;
  font-weight: 600;
}

.menu-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-main {
  min-width: 0;
}

.product-toolbar {
  margin-bottom: 20px;
  padding: 2px 0 18px;
  border-bottom: 1px solid #e3edf5;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.toolbar-kicker {
  color: #7d8fa3;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.product-toolbar h2 {
  margin-top: 5px;
  color: #142235;
  font-size: 24px;
  line-height: 1.35;
  font-weight: 800;
}

.product-count {
  min-height: 30px;
  padding: 0 11px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  background: #e9f8ff;
  color: #075b94;
  font-size: 13px;
  font-weight: 700;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
  gap: 18px;
}

.product-card {
  min-height: 300px;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
}

.product-card:hover {
  transform: translateY(-3px);
  border-color: rgba(44, 172, 226, 0.38);
  box-shadow: 0 18px 36px rgba(20, 34, 53, 0.11);
}

.product-img {
  height: 168px;
  padding: 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f9fc;
}

.product-img img {
  max-width: 100%;
  max-height: 132px;
  object-fit: contain;
}

.product-info {
  flex: 1;
  padding: 16px 18px 20px;
  display: flex;
  flex-direction: column;
}

.product-info h3 {
  color: #142235;
  font-size: 16px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-info p {
  margin-top: 9px;
  color: #607286;
  font-size: 13px;
  line-height: 1.58;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-info h3 + button {
  margin-top: 18px;
}

.product-info button {
  width: fit-content;
  min-width: 118px;
  min-height: 34px;
  margin-top: 13px;
  align-self: flex-end;
  padding: 0 18px;
  border: 1px solid rgba(44, 172, 226, 0.38);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f7fbfe;
  color: #075b94;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.22s ease, border-color 0.22s ease, color 0.22s ease;
}

.product-info button:hover {
  border-color: rgba(44, 172, 226, 0.7);
  background: #e9f8ff;
}

.empty-state {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7d8fa3;
}

.empty-state i {
  font-size: 42px;
  color: #b7c7d8;
}

.empty-state p {
  margin-top: 12px;
  font-size: 16px;
}

@media (max-width: 900px) {
  .product-panel {
    grid-template-columns: 1fr;
  }

  .product-sidebar {
    position: static;
    max-height: none;
  }
}

@media (max-width: 680px) {
  .product-panel {
    width: 94%;
    padding: 16px;
  }

  .product-toolbar {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>
